// extracted by mini-css-extract-plugin
export var formContainer = "ChangePasswordForm-module--formContainer--56bdc";